var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgJoivyIconSearch = function SvgJoivyIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.796 15.811 21 21m-3-10.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z",
    stroke: "#015962",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgJoivyIconSearch as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJTZWFyY2ggSWNvbiI+DQo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMTUuNzk1NSAxNS44MTExTDIxIDIxTTE4IDEwLjVDMTggMTQuNjQyMSAxNC42NDIxIDE4IDEwLjUgMThDNi4zNTc4NiAxOCAzIDE0LjY0MjEgMyAxMC41QzMgNi4zNTc4NiA2LjM1Nzg2IDMgMTAuNSAzQzE0LjY0MjEgMyAxOCA2LjM1Nzg2IDE4IDEwLjVaIiBzdHJva2U9IiMwMTU5NjIiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L2c+DQo8L3N2Zz4NCg==";